( function($) {
  $( document ).ready( function() {

    /**
     * UIKit dotnav aria fix
     */
    var dotnavFix = document.querySelectorAll( ".uk-dotnav li a" );

    dotnavFix.forEach( function( el ) {
      el.setAttribute( "aria-label", "Dotnav link" );
    } );



    /**
     * Coverflow settings
     */
    if ( $( '#coverflow' ).length > 0 ) {
      $( '#coverflow' ).coverflow( {
        angle: 0,
        active: 3,
        scale: 0.4,
        overlap: 1,
        trigger: {
          mousewheel: false,
          swipe: false,
        },
      } );

      $( '.items-container a' ).on( 'mouseover', function() {
        var href = $( this ).attr( 'href' );

        $( '.coverflow-container .' + href.substring(1) ).click();
      } );
    }

    if ( $( '#mobile-coverflow' ).length > 0 ) {
      $( '#mobile-coverflow' ).coverflow( {
        angle: 0,
        active: 3,
        scale: 0.4,
        overlap: 0.35,
        trigger: {
          mousewheel: true,
          swipe: true,
        },
      } );
    }



    // Remove any line paragraph tags in the accordion shortcode
    $( '.lemon-accordion-container' ).children( 'p' ).remove( 'p' );
    $( '.lemon-accordion-container' ).children().remove( 'br' );
    $( '.lh-image-slideshow-container ul' ).children( 'p' ).remove( 'p' );
    $( '.lh-image-slideshow-container ul' ).children().remove( 'br' );



    // Update and display current and total number of images list items
    var TotalLemonImages  = $( "#lemonSlider li" ).length;
    var CurrentLemonImage = 1;

    $( '#lemonSliderTotal' ).text( TotalLemonImages );
    $( '#lemonSliderCurrent' ).text( CurrentLemonImage );

    // Update function to display current image position
    UIkit.util.on( '#lemonSlider', 'itemshown', function() {
      var currentSlide = $( '#lemonSlider li.uk-active' ).index() + 1;

      $( '#lemonSliderCurrent' ).text( currentSlide );
    } );


    var TotalDonutImages  = $( "#donutSlider li" ).length;
    var CurrentDonutImage = 1;

    $( '#donutSliderTotal' ).text( TotalDonutImages );
    $( '#donutSliderCurrent' ).text( CurrentDonutImage );

    UIkit.util.on( '#donutSlider', 'itemshown', function() {
      var currentSlide = $( '#donutSlider li.uk-active' ).index() + 1;

      $( '#donutSliderCurrent' ).text( currentSlide );
    } );


    var TotalFranchiseImages  = $( "#contentSlider li" ).length;
    var CurrentFranchiseImage = 1;

    $( '#contentSliderTotal' ).text( TotalFranchiseImages );
    $( '#contentSliderCurrent' ).text( CurrentFranchiseImage );

    UIkit.util.on( '#contentSlider', 'itemshown', function() {
      var currentSlide = $( '#contentSlider li.uk-active' ).index() + 1;

      $( '#contentSliderCurrent' ).text( currentSlide );
    } );


    var TotalShortcodeImages  = $( "#shortcodeSlider li" ).length;
    var CurrentShortcodeImage = 1;

    $( '#shortcodeSliderTotal' ).text( TotalShortcodeImages );
    $( '#shortcodeSliderCurrent' ).text( CurrentShortcodeImage );

    UIkit.util.on( '#shortcodeSlider', 'itemshown', function() {
      var currentSlide = $( '#shortcodeSlider li.uk-active' ).index() + 1;

      $( '#shortcodeSliderCurrent' ).text( currentSlide );
    } );



    // Mobile Menu Toggles
    $( '.franchise-mobile-menu-toggle' ).on( 'click', function(e) {
      e.preventDefault();

      $( '#franchiseMobileMenuContainer' ).slideToggle();
    } );

    $( '.franchise-front-page-toggle' ).on( 'click', function(e) {
      e.preventDefault();

      $( '#nationalMenu' ).slideToggle();
    } );

    $( '.local-mobile-menu-toggle' ).on( 'click', function(e) {
      e.preventDefault();

      $( '#localNationalMenu' ).slideToggle();
    } );

    $( '.national-mobile-menu-toggle' ).on( 'click', function(e) {
      e.preventDefault();

      $( '#nationalMenu' ).slideToggle();
    } );
  } );
} )( jQuery );



var $j = jQuery.noConflict();
var cateringDropdown = $j( '#cateringSelection' );

function cateringSelection( option ) {
  var newUrl = option.value;

  $j( '#cateringURLButton' ).attr( 'href', newUrl );
}


/**
 * Dropdown Location Selection
 *
 * OLD CODE
 *
var selectionDropdown = $j( '#selectLocation' );

$j( document ).ready( function() {
  if( typeof( selectionDropdown ) !== 'undefined' && selectionDropdown !== null ) {
    selectionDropdown.click();
  }
} );

function locationSelection( option ) {
  selectionDropdown.attr( 'uk-filter-control', '[data-location-id="' + option.value + '"]' );
  selectionDropdown.click();

  var currentURL = $j( '.new-event-button' ).attr( 'href' );
  var url = new URL( currentURL );

  url.searchParams.set( "location_id", option.value ); // setting your param

  var newUrl = url.href;

  $j( '.new-event-button' ).attr( 'href', newUrl );
  $j( '.location-title' ).text( option.options[ option.selectedIndex ].innerHTML );
}
 */

/**
 * Dropdown Location Selection - Filters on Initial Load
 */
function locationSelection(option) {
  var selectedValue = option.value;
  console.log("selected Value", option.value);

  // Filter divs manually
  $j('[data-location-id]').each(function () {
    if ($j(this).data('location-id') == selectedValue) {
      $j(this).show(); // Show matching elements
    } else {
      $j(this).hide(); // Hide non-matching elements
    }
  });

  // Update the button link
  var currentURL = $j('.new-event-button').attr('href');
  var url = new URL(currentURL);
  url.searchParams.set("location_id", selectedValue);
  var newUrl = url.href;

  $j('.new-event-button').attr('href', newUrl);
  $j('.location-title').text(option.options[option.selectedIndex].innerHTML);
}
$j(document).ready(function () {
  var selectionDropdown = $j('#selectLocation');

  // Trigger filtering on initial load based on the selected option
  if (selectionDropdown.length) {
    locationSelection( selectionDropdown[0] );
    //var selectedOption = selectionDropdown.find('option:selected').val();
    //locationSelection({ value: selectedOption, options: selectionDropdown[0].options, selectedIndex: selectionDropdown[0].selectedIndex });
  }
});
